import { createContext } from 'react';

interface IsCreatingIntf {
  isCreating: boolean;
  setIsCreating: React.Dispatch<React.SetStateAction<boolean>>;
}

interface IsEditingIntf {
  isEditing: boolean;
  setIsEditing: React.Dispatch<React.SetStateAction<boolean>>;
}

export const IsCreatingCtx = createContext<IsCreatingIntf>({
  isCreating: false,
  setIsCreating: () => {},
});

export const IsEditingCtx = createContext<IsEditingIntf>({
  isEditing: false,
  setIsEditing: () => {},
});
